import React, { useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AppProvider, useApp } from './context/AppContext';
import Dashboard from './pages/Dashboard';
import Configuracao from './pages/Configuracao';
import Login from './pages/Login';
import MigrateData from './pages/MigrateData';
import Home from './pages/Home';
import ProtectedRoute from './components/ProtectedRoute';

// Component that uses theme from context
function AppContent() {
  const { currentTheme } = useApp();

  const theme = useMemo(() => createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: currentTheme.colors.primary,
      },
      secondary: {
        main: currentTheme.colors.secondary,
      },
      background: {
        default: currentTheme.colors.background.default,
        paper: currentTheme.colors.background.paper,
      },
      text: {
        primary: currentTheme.colors.text.primary,
        secondary: currentTheme.colors.text.secondary,
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h4: {
        fontWeight: 700,
      },
      h5: {
        fontWeight: 700,
      },
      h6: {
        fontWeight: 600,
      },
    },
  }), [currentTheme]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/migrate" element={<MigrateData />} />
          <Route
            path="/vendas"
            element={
              <ProtectedRoute>
                <Configuracao />
              </ProtectedRoute>
            }
          />
          <Route
            path="/corretores"
            element={
              <ProtectedRoute>
                <Configuracao />
              </ProtectedRoute>
            }
          />
          <Route
            path="/relatorio"
            element={
              <ProtectedRoute>
                <Configuracao />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comparativo"
            element={
              <ProtectedRoute>
                <Configuracao />
              </ProtectedRoute>
            }
          />
          <Route
            path="/apresentacao"
            element={
              <ProtectedRoute>
                <Configuracao />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configuracoes"
            element={
              <ProtectedRoute>
                <Configuracao />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;

